/**
 * DashboardQuickActions - Quick access actions
 *
 * WCAG 2.1 Level AA + BFSG konform
 * Light/Dark Mode Support
 */

import { Link } from 'react-router-dom';
import { Sparkles, Wallet2, Settings, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { EID } from '@/lib/element-ids.registry';
import type { ElementId } from '@/lib/element-ids.registry';

const actions = [
  {
    to: '/v2/tools',
    labelKey: 'dashboard.generateImage',
    labelFallback: 'Bild generieren',
    icon: Sparkles,
    color: 'bg-primary-100 text-primary-600 dark:bg-primary-900/40 dark:text-primary-400',
    eid: 'dashboard-quick-generate-link' as ElementId,
  },
  {
    to: '/v2/credits',
    labelKey: 'dashboard.topUpCredits',
    labelFallback: 'Credits aufladen',
    icon: Wallet2,
    color: 'bg-emerald-100 text-emerald-600 dark:bg-emerald-900/40 dark:text-emerald-400',
    eid: 'dashboard-quick-credits-link' as ElementId,
  },
  {
    to: '/v2/workspace/settings',
    labelKey: 'dashboard.workspaceSettings',
    labelFallback: 'Workspace Settings',
    icon: Settings,
    color: 'bg-amber-100 text-amber-600 dark:bg-amber-900/40 dark:text-amber-400',
    eid: 'dashboard-quick-settings-link' as ElementId,
  },
];

export function DashboardQuickActions() {
  const { t } = useTranslation();
  return (
    <div className="rounded-xl bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 p-5">
      <h3 className="text-sm font-semibold text-neutral-700 dark:text-neutral-300 mb-3">
        {t('dashboard.quickAccess')}
      </h3>
      <div className="space-y-1">
        {actions.map((action) => (
          <Link
            key={action.to}
            id={EID[action.eid]}
            to={action.to}
            className="flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-neutral-50 dark:hover:bg-neutral-800/60 transition-colors"
          >
            <div className={`flex items-center justify-center w-8 h-8 rounded-lg ${action.color}`}>
              <action.icon className="h-4 w-4" />
            </div>
            <span className="flex-1 text-sm font-medium text-neutral-700 dark:text-neutral-300">
              {t(action.labelKey, action.labelFallback)}
            </span>
            <ChevronRight className="h-4 w-4 text-neutral-400" />
          </Link>
        ))}
      </div>
    </div>
  );
}
